export abstract class BaseModel {
    id: number = 0;
}
